;"use strict";
 (function defButtonsCollection(global) {

  /**
  * Часто используемые селекторы
  */
  var toolBarConatainerSelector = "#toolbar_container";
  var groupSelector = "div.toolbar_group";
  var buttonSelector = "div.toolbar_button";
  var byNameSelectorTemplate = "{0}[name='{1}']";
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Класс-обертка для коллекции кнопок
  * @class WebAccess.components.wrappers.toolBar.Buttons
  * @extends WebAccess.Collecton
  * @since 5.2.0.1600
  */
  var Buttons = global.Collection.extend({

    // Список действий и соответствующих им кнопок на ленте.
    _buttonsByActionName: {},

    // Список режимов доступности и соответствующих им действий.
    _buttonsByEnabledMode: {},

    // Список кнопок, состояние которых изменяется в зависимости от выделения вложений
    _buttonsEnabledOnAttachmentSelection: [],

    /**
    * Часто-используемые jQuery объекты
    */

    init: function (elements) {
      var me = this;
      me._super(elements);

      // Сформировать списки
      me._arr.forEach(function (item) {
        // Действия и соответствующие им кнопки
        var linkedAction = item.getLinkedAction();
        var buttons = null;
        if (linkedAction) {
          buttons = me._buttonsByActionName[linkedAction];
          if (buttons) {
            buttons.push(item);
          } else {
            me._buttonsByActionName[linkedAction] = [item];
          }
        }

        // Режимы доступности и соответствующие им кнопки
        var enabledMode = item.getEnabledMode();
        if (enabledMode) {
          buttons = me._buttonsByEnabledMode[enabledMode];
          if (buttons) {
            buttons.push(item);
          } else {
            me._buttonsByEnabledMode[enabledMode] = [item];
          }
        }

        // Сформировать список кнопок, состояния которых изменяются в зависимости от выделения элементов
        if (item.getIsEnabledOnAttachnentSelected()) {
          me._buttonsEnabledOnAttachmentSelection.push(item);
        }
      });

      me._jToolBarConatainer = $(toolBarConatainerSelector),
      me._jSearchTarget = me._jToolBarConatainer.find(buttonSelector);
    },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Создать новую кнопку панели инструментов.
  *
  * @method WebAccess.components.wrappers.toolBar.Buttons#create
  * @param {string} toolGroupName Имя группы кнопок, в которую будет вложена кнопка.
  * @param {string | object} buttonName Имя создаваемой кнопки или объект {name: "", text:"", action:"", icon:""}
  * @param {BUTTON} opt_smallSized Размер кнопки. Возможные значения: LARGE, SMALL
  * @throws ERR_SPECIFIED_BUTTONS_GROUP_DOES_NOT_EXIST – указанной группы кнопок не существует;
  * @throws ERR_BUTTON_NAME_IS_NOT_SPECIFIED – неверно указано имя кнопки;
  * @throws ERR_BUTTON_WITH_THE_SAME_NAME_ALREADY_EXIST – кнопка с указанным именем уже существует.
  * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
  */
    create: function (toolGroupName, buttonName, opt_smallSized) {
      var me = this;
      if (arguments.length < 2) global.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED");
      var isSmall = opt_smallSized || false;
      var name = "";
      var text = L("NEW_BUTTON");
      var action = "alert(L('WRN_USE_CLICK_OR_BIND_METHODS_TO_SET_THE_ACTION'));";
      var icon = isSmall ? "Doc/doc_16.png" : "Doc/doc_32.png";
      var toolTip = text;

      if (typeof buttonName == "object") {
        //Шабардин П.: Не используется extend потому-что format в качестве шаблонизатора
        name = buttonName.name;
        text = buttonName.text ;
        action = buttonName.action;
        icon = buttonName.icon;
        toolTip = buttonName.toolTip || buttonName.tooltip;
      } else if (typeof buttonName == "string") {
        name = buttonName;
      } else global.raise("ERR_BUTTON_NAME_IS_NOT_SPECIFIED_PROPERLY");

      var currentGroupSelector = format(byNameSelectorTemplate, groupSelector, toolGroupName);
      var jToolGroup = me._jToolBarConatainer.find(currentGroupSelector);

      if (jToolGroup.length > 0) {
        var currentButtonSelector = format(byNameSelectorTemplate, isSmall ? "div.small_toolbar_item" : "div.toolbar_item", name);
        var jExistingButton = me._jToolBarConatainer.find(currentButtonSelector);
        if (jExistingButton.length > 0) global.raise("ERR_BUTTON_WITH_THE_SAME_NAME_ALREADY_EXIST", name);

        if (global.current.toolBar.groups[toolGroupName].isCollapsed()) jToolGroup = jToolGroup.find(".addedHiddenDiv");

        var buttonClass = isSmall ? "small_toolbar_item toolbar_button" : "toolbar_item toolbar_button";

        var jContainer;

        if (isSmall) {
          // Если в этой группе уже есть колонка, кол-вол элементов в которой меньше трех, то конечно добавляем в конец,
          // если нет, то создаем новую колонку и вкладываем в неё
          var jColumn = global.current.toolBar.groups[toolGroupName]._jObject.find(".toolbar_column:last");
          if (jColumn.length == 0 || jColumn.find(".small_toolbar_item").length == 3) {
            var jColumn = $('<div class="toolbar_column"></div>');
            jToolGroup.append(jColumn);
          };

          jContainer = jColumn;
        } else {
          jContainer = jToolGroup;
        };

        // Разные шаблоны для кнопки с svg-иконкой и, ради совместимости, для кнопки с png-иконкой.
        // Начиная с v5.5
        var buttonTemplate = (icon.substr(-4) === ".png") ? CT.toolBar.button : CT.toolBar.buttonSvg;
        jContainer.append(format(buttonTemplate.replace(/> {1,}</g, '><'), name, text, action, icon, buttonClass, toolTip));

        var button = new global.components.wrappers.toolBar.ToolBarButton(currentButtonSelector);
        button.isSynthetic = true;
        me.addElement(name, button);

        jExistingButton = me._jToolBarConatainer.find(currentButtonSelector);
        jExistingButton.hover(
          function () {
            $(this).addClass("hover");
          },
          function () {
            $(this).removeClass("hover");
          }
        );

        if (buttonName['jsaction']) {
          me[name].bind('click', buttonName['jsaction']);
        };

        return me[name];
      } else global.raise("ERR_SPECIFIED_BUTTONS_GROUP_DOES_NOT_EXIST", toolGroupName);
    },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Удалить кнопку панели инструментов.
    *
    * @method WebAccess.components.wrappers.toolBar.Buttons#remove
    * @param {string} buttonName Имя создаваемой кнопки панели инструментов
    * @return {WebAccess.current.toolBar.buttons} Пространство имен WebAccess.components.wrappers.toolBar.Buttons#
    */
    remove: function (buttonName) {
      var me = this;
      delete me[buttonName];
      me._jToolBarConatainer.find(format(byNameSelectorTemplate, buttonSelector, buttonName)).remove();

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверить наличие кнопки панели инструментов.
    *
    * @method WebAccess.components.wrappers.toolBar.Buttons#isExist
    * @param {string} buttonName Имя кнопки панели инструментов
    * @return {boolean} True, если кнопка существует, иначе False.
    */
    isExist: function (buttonName) {
      var existingButton = $(format(byNameSelectorTemplate, buttonSelector, buttonName));
      return existingButton.length > 0;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить список кнопок панели инструментов, которые зависят от указанного прикладного действия.
    * @function WebAccess.components.wrappers.toolBar.Buttons#getButtonsByActionName
    * @param {string} actionName Наименование прикладного действия.
    * @returns {array} Массив кнопок панели инструментов, которые зависят от указанного прикладного действия.
    */
    getButtonsByActionName: function (actionName) {
      var buttons = this._buttonsByActionName[actionName.toLowerCase()];
      return buttons ? buttons : [];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить список кнопок панели инструментов по режиму доступности.
    * @function WebAccess.components.wrappers.toolBar.Buttons#getButtonsByEnabledMode
    * @param {ACTION_ENABLED_MODE} enabledMode Режим доступности действия.
    * @returns {array} Массив кнопок панели инструментов, для которых установлен соответствующий режим доступности.
    */
    getButtonsByEnabledMode: function (enabledMode) {
      var buttons = this._buttonsByEnabledMode[enabledMode];
      return buttons ? buttons : [];
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить список кнопок панели инструментов, состояния которых изменяются в зависимости от выделения вложений.
    * @function WebAccess.components.wrappers.toolBar.Buttons#getButtonsEnabledOnAttachmentSelection
    * @returns {array} Массив кнопок панели инструментов, состояния которых изменяются в зависимости от выделения вложений.
    */
    getButtonsEnabledOnAttachmentSelection: function () {
      return this._buttonsEnabledOnAttachmentSelection;
    }
  });

  global.components.wrappers.toolBar.Buttons = Buttons;

})(window.WebAccess);
